import { Component, Input, OnInit } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CartService } from '../../appshared/invoice/cart.service';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-success-page',
  standalone: true,
  imports: [FontAwesomeModule,
    TranslateModule],
  templateUrl: './success-page.component.html',
  styleUrl: './success-page.component.css',
})
export class SuccessPageComponent implements OnInit {
  IsSuccess: boolean = true;
  private sub: any;
  thisID: number = 0;

  constructor(
    private cartService: CartService,
    public translate: TranslateService, private route: ActivatedRoute, private router: Router
  ) { }



  ngOnInit(): void {

    this.sub = this.route.params.subscribe(params => {
      this.thisID = +params['id'];
    });

    if (this.thisID == 0) {
      this.IsSuccess = false;
    }
    else {
      this.cartService.clearCart();
    }
  }

  @Input() amount: string = '154.00';
  @Input() currency: string = 'OMR';
  @Input() referenceNumber: string = '000086752257';
  @Input() paymentTime: string = '25-02-2023, 13:22:16';
  @Input() paymentMethod: string = 'Bank Transfer';
  @Input() senderName: string = 'Ahmed Hassan';
  @Input() adminFee: string = '12.00';
  @Input() logoUrl: string = '../../../assets/img/logo.png';
  @Input() direction: 'rtl' | 'ltr' = 'rtl';

  faCheckCircle = faCheckCircle;

  labels = {
    refNumber: 'Ref Number',
    paymentTime: 'Payment Time',
    paymentMethod: 'Payment Method',
    senderName: 'Sender Name',
    adminFee: 'Admin Fee',
    downloadPDF: 'PDF تحميل',
  };

  downloadPDF() {
    // Implement PDF download logic here
    console.log('Downloading PDF...');
  }
}
